import { DoorTailgateGridsEnabledQuery } from '@/graphql/generated/operations'

export interface EntityI {
  id: string
}

export const getById = <T extends EntityI>(list: T[], id: string): T => {
  return list.find((d) => d.id === id)
}

// Checks if any of the device door tailgate grids have tailgating enabled
// Returns true/false
export const isTailgatingEnabledForOtherDevices = (
  data: DoorTailgateGridsEnabledQuery,
  cameraId: string
) =>
  data?.device?.door?.tailgateGrids?.some(
    (grid) => grid.isTailgateEnabled === true && grid.camera.id !== cameraId
  )
